import { useRef } from "react";
import {
  Flex,
  Tooltip,
  AlertDialog,
  AlertDialogHeader,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogBody,
  AlertDialogFooter,
  Divider,
  Grid,
  GridItem,
  Heading,
  Progress,
  Button,
  Box,
  Text
} from "@chakra-ui/react";
import { useAppSelector } from "lib/redux";
import { selectSubscription } from "domains/subscription";
import { BiHelpCircle } from '@react-icons/all-files/bi/BiHelpCircle';

export const TeamUsageAlert = ({ isOpen, onClose }) => {
  const { bandwidth_used, storage_used } = useAppSelector(selectSubscription);
  const cancelRef = useRef();

  return (
    <AlertDialog
      motionPreset="slideInBottom"
      leastDestructiveRef={cancelRef}
      onClose={onClose}
      isOpen={isOpen}
      isCentered
    >
      <AlertDialogOverlay />
      <AlertDialogContent>
        <AlertDialogHeader>App Usage</AlertDialogHeader>
        <AlertDialogBody>
          <Grid autoFlow="column" justifyContent="space-between">
            <GridItem>
              <Flex alignItems="center">
                <Heading as="h3" size="sm">Storage used</Heading>
                <Box paddingLeft="10px">
                  <Tooltip hasArrow label="The total storage used by your team" placement="top">
                    <span style={{color: 'var(--color-text-secondary)'}}>
                      <BiHelpCircle />
                    </span>
                  </Tooltip>
                </Box>
              </Flex>
            </GridItem>
            <GridItem>
              {(storage_used/1_000_000_000).toFixed(3)} GB used
            </GridItem>
          </Grid>
          <Divider className="spaced-divider" />
          <Grid autoFlow="column" justifyContent="space-between">
            <GridItem>
              <Flex alignItems="center">
                <Heading as="h3" size="sm">Daily bandwidth usage</Heading>
                <Box paddingLeft="10px">
                  <Tooltip hasArrow label="The bandwidth used by your team for today." placement="top">
                    <span style={{color: 'var(--color-text-secondary)'}}>
                      <BiHelpCircle />
                    </span>
                  </Tooltip>
                </Box>
              </Flex>
            </GridItem>
            <GridItem>
              {(bandwidth_used/1_000_000_000).toFixed(3)} GB used
            </GridItem>
          </Grid>
        </AlertDialogBody>
        <AlertDialogFooter>
          <Button
            type="submit"
            variant="solid"
            className="button button--minimal button--cancel"
            autoFocus={false}
            onClick={onClose}
            ref={cancelRef}
          >
            Close
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
};
